import { useTheme } from '../../contexts/ThemeContext'
import { THEMES, THEME_LABELS } from '../../lib/themes'

export default function ThemeSelector() {
  const { themeKey, setTheme, theme } = useTheme()

  return (
    <div style={s.container}>
      <p style={{ ...s.label, color: theme.inkLight }}>personaliza tu espacio</p>
      <div style={s.grid}>
        {Object.keys(THEMES).map(key => {
          const t = THEMES[key]
          const active = key === themeKey
          return (
            <button
              key={key}
              onClick={() => setTheme(key)}
              style={{
                ...s.card,
                background: t.paper,
                border: active ? `2px solid ${t.accent}` : `1.5px solid ${t.cardBorder}`,
                boxShadow: active ? `0 4px 16px ${t.accentDeep}33` : 'none',
              }}
            >
              <div style={s.swatchRow}>
                <div style={{ ...s.swatch, background: t.accent }} />
                <div style={{ ...s.swatch, background: t.sage }} />
                <div style={{ ...s.swatch, background: t.gold }} />
              </div>
              <span style={{ ...s.name, color: t.inkMid }}>{THEME_LABELS[key]}</span>
              {active && <span style={{ ...s.checkmark, color: t.accent }}>✓</span>}
            </button>
          )
        })}
      </div>
    </div>
  )
}

const s = {
  container: { marginBottom: 8 },
  label: {
    fontSize: 11, letterSpacing: 1.5, textTransform: 'uppercase',
    fontWeight: 500, margin: '0 0 12px',
    fontFamily: "'DM Sans', sans-serif",
  },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 },
  card: {
    borderRadius: 16, padding: '14px 12px',
    cursor: 'pointer', textAlign: 'left',
    transition: 'all 0.2s', position: 'relative',
  },
  swatchRow: { display: 'flex', gap: 5, marginBottom: 8 },
  swatch: { width: 18, height: 18, borderRadius: '50%' },
  name: {
    fontFamily: "'DM Sans', sans-serif", fontSize: 12,
    fontWeight: 500, display: 'block',
  },
  checkmark: {
    position: 'absolute', top: 8, right: 10,
    fontSize: 14, fontWeight: 700,
  },
}
